const secondListenSection = {
  name: 'Strategy in practice and culture - Continued p3',
  elements: [
  ]
}

export default secondListenSection
